import { render, staticRenderFns } from "./SectionTable.vue?vue&type=template&id=784c5ba9&scoped=true"
import script from "./SectionTable.vue?vue&type=script&lang=js"
export * from "./SectionTable.vue?vue&type=script&lang=js"
import style0 from "./SectionTable.vue?vue&type=style&index=0&id=784c5ba9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c5ba9",
  null
  
)

export default component.exports